// extracted by mini-css-extract-plugin
export var backdrop = "index-module--backdrop--Elx0w";